<template>
    <div>
        <div>
            <div class="card card-default">
                <div class="card-header">
                    <div class="vx-flex vx-justify-between vx-items-center">
                        <span>API Tokens</span>
                        <div>
                            <a href="#" class="action-link" @click.prevent="createToken()">Create API Token</a>
                        </div>
                    </div>
                </div>

                <div v-if="!tokens.length" class="card-body">
                    <p>You have not created any API Tokens.</p>
                </div>
                <div v-else-if="tokens.length > 0" class="table-responsive">
                    <table class="table table-valign-middle mb-0">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Created</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="token in tokens" :key="token.id">
                                <!-- Name -->
                                <td>
                                    <div>
                                        {{ token.name }}
                                    </div>
                                </td>

                                <!-- Created At -->
                                <td>
                                    <div>
                                        {{ dateTime(token.created_at) }}
                                    </div>
                                </td>

                                <!-- Edit Button -->
                                <td class="td-fit">
                                    <div class="text-right">
                                        <button class="btn btn-outline-primary" @click="editToken(token)">
                                            <i class="fa fa-cog"></i>
                                        </button>

                                        <button class="btn btn-outline-danger" @click="deleteToken(token)">
                                            <i class="fa fa-remove"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <api-token-form-modal v-model="createOrUpdateToken"></api-token-form-modal>
    </div>
</template>

<script>
import { getClientTz } from '~/utils/date';
import dayjs from '~/utils/dayjs';
import axios from '~/services/axios';
import { VxSwal } from '@voxie/frontend-components';
import ApiTokenFormModal from '~/components/settings/api/ApiTokenFormModal.vue';
import { throwSwalRequestError } from '~/utils/request';

export default {
    props: ['tokens'],
    components: {
        ApiTokenFormModal,
    },

    /**
     * The component's data.
     */
    data() {
        return {
            createOrUpdateToken: null,
        };
    },

    methods: {
        dateTime(value) {
            return dayjs.utc(value).tz(getClientTz()).format('MMMM Do, YYYY h:mm A');
        },

        createToken() {
            this.createOrUpdateToken = { name: '' };
        },
        editToken(token) {
            this.createOrUpdateToken = { ...token };
        },

        deleteToken(token) {
            VxSwal.fire({
                title: 'Delete Token',
                icon: 'danger',
                showCancelButton: true,
                confirmButtonColor: 'danger',
                confirmButtonText: 'Yes, Delete',
                html: `Are you sure you want to delete this token <strong class="vx-font-bold">"${token.name}"</strong>? If deleted, API requests that attempt to authenticate using this token will no longer be accepted.`,
                preConfirm: () =>
                    axios
                        .delete(`/settings/api/token/${token.id}`)
                        .then(() => {
                            Bus.$emit('updateTokens');
                        })
                        .catch(throwSwalRequestError),
            });
        },
    },
};
</script>
